const localizers = {
  'loading.msg': () => `Indlæser...`,
  'logon.message.msg': () => `Validering er påkrævet. Skriv et gyldigt bruger-id og en gyldig adgangskode.`,
  'logon.button.msg': () => `Logon...`,
  'SASServer.logonError.msg': () => `Der kunne ikke logges på serveren.`,
  'SASServer.genericError.msg': () => `Der kan ikke oprettes forbindelse til serveren.`,
}
export default localizers;
